var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 160,
    viewBox: "0 0 220 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80,
    r: 80,
    fill: "#EEF7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 20,
    r: 8,
    fill: "#EEF7FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 126,
    r: 6,
    fill: "#EEF7FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 138,
    r: 10,
    fill: "#EEF7FE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46,
    r: 10,
    fill: "#EEF7FE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 11,
    r: 7,
    fill: "#EEF7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8771_634314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.486 16C96.7495 16 81.9448 24.2701 72.9354 36.9466C69.9934 36.2528 66.9253 35.8857 63.7714 35.8857C41.8063 35.8857 24 53.692 24 75.6571C24 97.6223 41.8063 115.429 63.7714 115.429H163.177C163.185 115.429 163.193 115.429 163.2 115.429C182.42 115.429 198 99.8481 198 80.6286C198 61.4091 182.42 45.8286 163.2 45.8286C161.835 45.8286 160.488 45.9072 159.164 46.0602C151.546 28.3784 133.961 16 113.486 16Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.7714,
    cy: 75.6572,
    r: 39.7714,
    fill: "url(#paint0_linear_8771_634314)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.486,
    cy: 65.7143,
    r: 49.7143,
    fill: "url(#paint1_linear_8771_634314)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.2,
    cy: 80.6281,
    r: 34.8,
    fill: "url(#paint2_linear_8771_634314)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8771_634314)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 84,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#2C74D6",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 125H115M110 125V117M118 110C118 106.835 117.995 101.586 117.993 100C117.993 99.7348 117.887 99.4804 117.7 99.2929C117.512 99.1054 117.258 99 116.993 99L103.006 99.0162C102.741 99.0162 102.487 99.1212 102.3 99.308C102.112 99.4949 102.007 99.7485 102.006 100.013C102.006 101.924 101.998 108.086 101.998 110C101.998 114.017 107.185 117 109.998 117C112.81 117 118 114.017 118 110Z",
    stroke: "#EEF7FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 102H97V103C97 106.451 99.0969 110 102 110M118 102H123V103C123 106.451 120.903 110 118 110",
    stroke: "#EEF7FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8771_634314",
    x: 4,
    y: 16,
    width: 214,
    height: 139.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8771_634314"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8771_634314"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8771_634314"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8771_634314",
    result: "effect2_dropShadow_8771_634314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8771_634314",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8771_634314",
    x: 74,
    y: 76,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8771_634314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8771_634314",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8771_634314",
    x1: 33.2326,
    y1: 49.3796,
    x2: 103.543,
    y2: 115.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8771_634314",
    x1: 75.3123,
    y1: 32.8673,
    x2: 163.2,
    y2: 115.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8771_634314",
    x1: 136.479,
    y1: 57.6353,
    x2: 198,
    y2: 115.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRewards);
export default "data:image/svg+xml,%3csvg width='220' height='160' viewBox='0 0 220 160' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='110' cy='80' r='80' fill='%23EEF7FE'/%3e %3ccircle cx='26' cy='20' r='8' fill='%23EEF7FE'/%3e %3ccircle cx='198' cy='126' r='6' fill='%23EEF7FE'/%3e %3ccircle cx='25' cy='138' r='10' fill='%23EEF7FE'/%3e %3ccircle cx='210' cy='46' r='10' fill='%23EEF7FE'/%3e %3ccircle cx='191' cy='11' r='7' fill='%23EEF7FE'/%3e %3cg filter='url(%23filter0_dd_8771_634314)'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M113.486 16C96.7495 16 81.9448 24.2701 72.9354 36.9466C69.9934 36.2528 66.9253 35.8857 63.7714 35.8857C41.8063 35.8857 24 53.692 24 75.6571C24 97.6223 41.8063 115.429 63.7714 115.429H163.177C163.185 115.429 163.193 115.429 163.2 115.429C182.42 115.429 198 99.8481 198 80.6286C198 61.4091 182.42 45.8286 163.2 45.8286C161.835 45.8286 160.488 45.9072 159.164 46.0602C151.546 28.3784 133.961 16 113.486 16Z' fill='%23EEF7FE'/%3e %3ccircle cx='63.7714' cy='75.6572' r='39.7714' fill='url(%23paint0_linear_8771_634314)'/%3e %3ccircle cx='113.486' cy='65.7143' r='49.7143' fill='url(%23paint1_linear_8771_634314)'/%3e %3ccircle cx='163.2' cy='80.6281' r='34.8' fill='url(%23paint2_linear_8771_634314)'/%3e %3c/g%3e %3cg filter='url(%23filter1_b_8771_634314)'%3e %3crect x='82' y='84' width='56' height='56' rx='28' fill='%232C74D6' fill-opacity='0.4'/%3e %3cpath d='M105 125H115M110 125V117M118 110C118 106.835 117.995 101.586 117.993 100C117.993 99.7348 117.887 99.4804 117.7 99.2929C117.512 99.1054 117.258 99 116.993 99L103.006 99.0162C102.741 99.0162 102.487 99.1212 102.3 99.308C102.112 99.4949 102.007 99.7485 102.006 100.013C102.006 101.924 101.998 108.086 101.998 110C101.998 114.017 107.185 117 109.998 117C112.81 117 118 114.017 118 110Z' stroke='%23EEF7FE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M102 102H97V103C97 106.451 99.0969 110 102 110M118 102H123V103C123 106.451 120.903 110 118 110' stroke='%23EEF7FE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/g%3e %3cdefs%3e %3cfilter id='filter0_dd_8771_634314' x='4' y='16' width='214' height='139.429' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='4' operator='erode' in='SourceAlpha' result='effect1_dropShadow_8771_634314'/%3e %3cfeOffset dy='8'/%3e %3cfeGaussianBlur stdDeviation='4'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_8771_634314'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='4' operator='erode' in='SourceAlpha' result='effect2_dropShadow_8771_634314'/%3e %3cfeOffset dy='20'/%3e %3cfeGaussianBlur stdDeviation='12'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0'/%3e %3cfeBlend mode='normal' in2='effect1_dropShadow_8771_634314' result='effect2_dropShadow_8771_634314'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_8771_634314' result='shape'/%3e %3c/filter%3e %3cfilter id='filter1_b_8771_634314' x='74' y='76' width='72' height='72' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeGaussianBlur in='BackgroundImageFix' stdDeviation='4'/%3e %3cfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_8771_634314'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_8771_634314' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_8771_634314' x1='33.2326' y1='49.3796' x2='103.543' y2='115.429' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_8771_634314' x1='75.3123' y1='32.8673' x2='163.2' y2='115.428' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_8771_634314' x1='136.479' y1='57.6353' x2='198' y2='115.428' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };